import kebabCase from 'lodash.kebabcase'
import { EClass } from '@/modules/_misc'
import type { TSpotlightResponseItem } from './Spotlight'

export const getSpotlightResultLink = (value: TSpotlightResponseItem): string | null => {
  switch (value.clazz) {
    case EClass.Expense: {
      return `/accounting/purchase/expense/${value.id}`
    }
    case EClass.BelgianDepartingFlightTaxesExpense: {
      return `/accounting/purchase/belgian-departing-flight-taxes-expense/${value.id}`
    }
    case EClass.Invoice: {
      return `/accounting/sale/invoice/${value.id}`
    }
    case EClass.AircraftOwnerInvoice: {
      return `/accounting/sale/aircraft-owner-invoice/${value.id}`
    }
    case EClass.MissionInvoice: {
      return `/accounting/sale/mission-invoice/${value.id}`
    }
    case EClass.Organisation: {
      return `/entities/organisation/${value.id}`
    }
    case EClass.Person:
    case EClass.User: {
      return `/entities/person/${value.id}`
    }
    case EClass.Membership: {
      return `/accounting/members/membership/${value.id}`
    }
    case EClass.BankAccount: {
      return `/accounting/payment-mean/bank-account/${value.id}`
    }
    case EClass.CreditCard: {
      return `/accounting/payment-mean/credit-card/${value.id}`
    }
    case EClass.Domiciliation: {
      return `/accounting/payment-mean/domiciliation/${value.id}`
    }
    case EClass.CarResource:
    case EClass.SIMCardResource:
    case EClass.FuelCardResource:
    case EClass.ITResource:
    case EClass.AssetResource: {
      return `/human-resources/asset-resource/${kebabCase(value.clazz)}/${value.id}`
    }
    default: {
      return null
    }
  }
}
